<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="'pages.bulkNumberInformation.deleteFromFile.title'"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
    [showRefreshBtn]="false"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <form autocomplete="off" [formGroup]="form">
      <fieldset>
        <div class="md:tw-w-1/2">
          <file-uploader
            [label]="fields + 'selectfile'"
            [control]="form?.get('inputFile')"
            class="tw-w-[275px]"
            (valueChange)="checkFile($event)"
            acceptFile=".xls,.xlsx,.csv"
            [maxFileSize]="100"
            sizeType="mb"
            (onErrorFile)="showErrorDialog($event)"
          >
          </file-uploader>
        </div>
      </fieldset>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="false"
        (onClose)="onClose()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
